import React, { FC, ReactElement } from 'react'

import { Absence } from '../../../../entities/Absence/Absence'
import { AbsenceListItem } from '../index'

interface AbsencesListProps {
    absences: Absence[];
    className?: string;
}

const AbsencesList: FC<AbsencesListProps> = ({ absences, className }): ReactElement => (
    <ul className={`absences-list ${className}`}>
        {absences.map((absence) => (
            <AbsenceListItem
                key={absence.id}
                absence={absence}
                className="absences-list__item"
            />
        ))}
    </ul>
)

export default AbsencesList
